import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService, UtilityService } from 'src/app/services';
import { CustomValidations } from '../../../custom-validations';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent implements OnInit {
  changePassword: FormGroup;
  currentPassword = new FormControl ('', Validators.required );
  newPassword = new FormControl( '', Validators.required );
  confirmPassword = new FormControl( '', Validators.required );
  hide = true;
  hide_new_password = true;
  hide_confirm_password = true;
  listItem: any = '';

  constructor(private fb: FormBuilder ,private snackbar: MatSnackBar, private http: HttpService, private util: UtilityService) {
  }

  ngOnInit(): void {
    this.changePasswordForm();
  }

  changePasswordForm() {
    this.changePassword = this.fb.group ({
      old_password: this.currentPassword,
      new_password: this.newPassword,
      re_password: this.confirmPassword,
    });
  }

  submit() {
    if(this.changePassword.valid) {
      this.http.flightsave(`apiV2/user/password-update`, this.changePassword.value).subscribe(res => {
          if(res.statusCode === 200) {
            this.listItem = res;
            this.snackbar.open(this.listItem.message, 'success', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          }
        },
        err => {
          if(err?.error !== 200) {
            this.listItem = err?.error;
            this.util.errorMessage(err);
            this.snackbar.open(err?.error?.message, 'Error', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          }
        }
      )
    }
  }
}
